import React from 'react';
import BaseContainer from "../BaseContainer";
import Accordion from './Accordion';
import { pureKeys } from "../../utils/helpers"

const TextAccordionComp = ({ data })=> {
  const {TextAccordionData} = data;

  const renderTextAccordion = ()=>{
    return TextAccordionData && TextAccordionData.map((item)=>{
        return <article key={pureKeys(item.title)} className='pb-[40px] lg:pb-[60px] last:pb-[0px]'>
          {item.title && item.title !== "" && <header className="text-[28px] lg:text-[32px] text-black font-medium leading-[41.6px] tracking-[0.32px] pb-[20px] lg:pb-[30px]">{item.title}</header>}
          {renderAccordionItem(item.AccordionItem, item.NewLabelText)}
        </article>
    })
  }

  const renderAccordionItem =(accordionItem, newLabelText)=>{
    return accordionItem && accordionItem.map((item, index)=>{
      return <section key={index} className="mb-1 last:mb-0"><Accordion accordion={item} index={index} newLabelText={newLabelText} /></section>
    })
    
    
  }

  return (
    <>
      <BaseContainer className='mt-[40px] lg:mt-[80px] mb-[40px] lg:mb-[80px]'>
        <div>
          {renderTextAccordion()}
        </div>
      </BaseContainer>
    </>
  )
}

export default TextAccordionComp;